import { Pipe, PipeTransform } from '@angular/core';
import { TextTransformService } from '../services/text-transform.service';

@Pipe({
  name: 'separator'
})
export class SeparatorPipe implements PipeTransform {

  transform(value: any, chainLength: number = 3, separator: string = ' '): any {
    if (typeof value === 'number') {
      value = value.toString();
    }
    return TextTransformService.separateValues(value, {
      charsChain: chainLength,
      separator: separator
    });
  }

}
